import { useEffect, useMemo } from 'react';
import { useAnalyticsOrgLocations } from '@frontend/analytics-shared';
import { getPageSubtitleText } from '../utils/get-page-subtitle-text';
import { useIsPhoneAnalyticsDemoAccount } from './use-is-phone-analytics-demo-account';
import { usePhoneAnalyticsDemoData } from './use-phone-analytics-demo-data';
import { usePhoneAnalyticsShallowStore } from './use-phone-analytics-store';

export const useOnPhoneAnalyticsPageLoad = () => {
  const { filterHintText, filters, setStore } = usePhoneAnalyticsShallowStore('filterHintText', 'filters', 'setStore');
  const isDemoAccount = useIsPhoneAnalyticsDemoAccount();
  const demoData = usePhoneAnalyticsDemoData();

  const { hasAccessToMultipleLocations } = useAnalyticsOrgLocations({
    isAllAccessScopeEnabled: true,
    isDemoAccount,
    module: 'PHONE',
  });

  const pageSubtitle = useMemo(
    () => getPageSubtitleText({ filters, filterHintText, hasAccessToMultipleLocations }),
    [filters, filterHintText, hasAccessToMultipleLocations]
  );

  useEffect(() => {
    setStore({ demoData });
  }, [demoData, setStore]);

  useEffect(() => {
    setStore({ isDemoAccount });
  }, [isDemoAccount, setStore]);

  return {
    filterHintText,
    filters,
    isDemoAccount,
    pageSubtitle,
  };
};
